import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-upairy-tabs.js';

const DEFAULT_VIDEO_1 = 'https://cdn.shopify.com/videos/c/o/v/00ab987739624f1aa3e30d7838f23e29.mp4';

const DEFAULT_VIDEO_2 = 'https://cdn.shopify.com/videos/c/o/v/d87905fc00b64418aca0877efbb53cde.mp4';

const DEFAULT_IMAGE = 'https://cdn.skyfastimg.com/images/2026/08/04/image-6a718fa085c7ae48f2f6216c.webp?w=1000';

const defaultItems = [
  {
    header: 'THE CAUSE',
    mediaType: 'video',
    image: '',
    video: DEFAULT_VIDEO_1,
    value: `<p>Diapers absorb everything instantly, so toddlers never feel when they pee - their brains can't make the connection.&nbsp;</p><p><span style="font-size:18px;"><strong>How This Creates Problems</strong></span></p><p>&nbsp;🚫 <strong>No Wetness Feedback</strong> — can't feel when they've peed&nbsp;</p><p>⏰ <strong>Months of Training</strong> — no discomfort, means no motivation to change</p><p>🔄 <strong>Daily Accidents</strong> — comfortable after every pee, the cycle repeats</p>`,
  },
  {
    header: 'THE SOLUTION',
    mediaType: 'video',
    image: '',
    video: DEFAULT_VIDEO_2,
    value: `<p>Our 3-layer system lets toddlers feel their accidents to learn while protecting your floors from full accidents.</p><p><span style="font-size:18px;"><strong>How This Helps</strong></span>&nbsp;</p><p><strong>💧 Feel Wetness</strong> — get the feedback pull-ups prevent&nbsp;</p><p>🛡️<strong> Protect Floors </strong>— waterproof layer catches accidents&nbsp;</p><p>🧠 <strong>Learn Faster</strong> — discomfort drives behavior change</p>`,
  },
  {
    header: 'THE RESULTS',
    mediaType: 'image',
    image: DEFAULT_IMAGE,
    video: '',
    value: `<p>When toddlers feel wetness, they start connecting body signals to potty use—building awareness diapers block.&nbsp;</p><p><span style="font-size:18px;"><strong>What Parents See</strong></span></p><p>⚡ <strong>Kids Notice </strong>— recognize when they're wet to use the potty next time</p><p>&nbsp;📉 <strong>Fewer Accidents</strong> — motivated to stay dry&nbsp;</p><p>💪<strong> More Awareness</strong> — learn to use potty before accidents</p><p>That awareness is what makes potty training happen MUCH faster.`,
  },
];

const renderTab = (item, index) => `
  <div
    class="upairy-tabs__tab${index === 0 ? ' active' : ''}"
    data-attribute="upairy-tabs__tab"
    data-index="${index}"
    data-active="${index === 0 ? 'true' : 'false'}"
  >${item.header}</div>
`;

const renderMedia = item => {
  if (item.mediaType === 'video') {
    return `
      <video
        class="upairy-tabs__media"
        data-attribute="upairy-tabs__video"
        autoplay
        muted
        loop
        playsinline
      ><source src="${item.video}" type="video/mp4" /></video>
    `;
  }

  return `
    <img
      loading="lazy"
      class="upairy-tabs__media"
      data-attribute="upairy-tabs__image"
      src="${item.image}"
      alt="Upairy tab media"
    />
  `;
};

const renderSlide = item => `
  <div class="swiper-slide" data-attribute="upairy-tabs__item">
    <article class="upairy-tabs__content">
      <div class="upairy-tabs__media-wrapper" data-attribute="upairy-tabs__media-wrapper">
        ${renderMedia(item)}
      </div>
      <div class="upairy-tabs__body" data-attribute="upairy-tabs__value">${item.value}</div>
    </article>
  </div>
`;

const contentHtml = `
  <div
    class="upairy-tabs container"
    data-attribute="upairy-tabs"
    data-tab-header-color="#000000"
    data-image-border-radius="9999"
    data-image-width="296"
    data-image-position="left"
    style="
      --tab-header-color: #000000;
      --image-border-radius: 9999px;
      --image-width: 296px;
    "
  >
    <div class="upairy-tabs__header" data-attribute="upairy-tabs__header">
      <h2 style="text-align: center">
        <span style="color: hsl(102, 32%, 42%)"><strong>The Science</strong></span
        ><br /><strong>Potty training, every parent's biggest challenge</strong>
      </h2>
      <p style="text-align: center">
        Potty training is a developmental milestone all families will deal with.
        &nbsp;Our training pants use child development principles to help kids learn
        faster, restoring family peace and building confident, independent children.
      </p>
    </div>
    <div
      class="upairy-tabs__tabs"
      data-attribute="upairy-tabs__tabs"
      role="tablist"
    >
      ${defaultItems.map(renderTab).join('')}
    </div>
    <div class="swiper upairy-tabs__swiper">
      <div class="swiper-wrapper" data-attribute="upairy-tabs__list">
        ${defaultItems.map(renderSlide).join('')}
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css);
